import React, { FC, useState } from 'react';
import { StandardDocumentsContainer } from './StandardDocumentsContainer';
import { ClosingProtectionLetterContainer } from './ClosingProtectionLetterContainer';
import { AffidavitsContainer } from './AffidavitsContainer';
import { useSetOrderNavigationTab } from '../../../utilities/hooks/useSetOrderNavigationTab';
import { OrderTabs } from 'store/order/orderNavigation/orderNavigationSlice';
import { AssociatedLendersProvider } from '../../../ui-toolkit/associatedLenders/AssociatedLendersProvider';

export const DocumentsPage: FC = () => {
  useSetOrderNavigationTab({ tab: OrderTabs.Documents });
  const [isZDocLoading, setIsZDocLoading] = useState(false);
  return (
    <>
      <StandardDocumentsContainer isZDocLoading={isZDocLoading} />
      <AffidavitsContainer setIsZDocLoading={setIsZDocLoading} />
      <AssociatedLendersProvider>
        <ClosingProtectionLetterContainer />
      </AssociatedLendersProvider>
    </>
  );
};
